<template>
  <div id="leveling-wrap">
    <div class="character-level">
        <label for="characterLevel">Level</label>
        <input 
          name="characterLevel" 
          type="number" 
          min="1"
          v-model.number="level">
      </div>
      <div class="character-xp">
        <label for="characterXP">XP</label>
        <input 
          name="characterXP" 
          type="number"
          min="0"
          v-model.number="xp">
      </div>
  </div>
</template>

<script>
export default {
  name: 'CharacterLeveling',
  data() {
    return {
      // level: 1,
      // xp: 0
    }
  },
  computed: {
    level: {
      get() {
        return this.$store.state.character.level;
      },
      set(value) {
        this.$store.commit('updateCharacterProperty', { type: 'level', property: value });
      }
    },
    xp: {
      get() {
        return this.$store.state.character.xp;
      },
      set(value) {
        this.$store.commit('updateCharacterProperty', { type: 'xp', property: value });
      }
    }
  }
}
</script>
<style lang="css">
  #leveling-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  #leveling-wrap input {
    width: 2em;
    height: 2em;
    text-align: center;
    margin-top: 4px;
    border: 1px solid #2c3e50;
    border-radius: 100%;
  }

  .character-level, .character-xp {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 30%;
  }
</style>